import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Divider,
  Button,
  LinearProgress
} from '@mui/material';
import {
  LocationOn,
  People,
  Event,
  Person,
  Assessment,
  Download
} from '@mui/icons-material';

const GroupOverview = ({ group, formatDate, setLocalActiveTab }) => {
  return (
    <Grid container spacing={3}>
      {/* Group Details */}
      <Grid item xs={12} md={6}>
        <Paper sx={{ p: 2 }}>
          <Typography variant="h6" gutterBottom color="primary">
            Group Details
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <LocationOn color="primary" sx={{ mr: 1 }} />
              <Typography>{group.location}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <People color="primary" sx={{ mr: 1 }} />
              <Typography>
                {group.active_members} active / {group.member_count} total members
              </Typography>
            </Box>
            <Divider />
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Event color="primary" sx={{ mr: 1 }} />
              <Box>
                <Typography variant="subtitle2">Next Meeting</Typography>
                <Typography>
                  {formatDate(group.next_meeting_date)} - {group.next_meeting_point || 'Location TBD'}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Event color="primary" sx={{ mr: 1 }} />
              <Box>
                <Typography variant="subtitle2">Previous Meeting</Typography>
                <Typography>{formatDate(group.prev_meeting_date)}</Typography>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Person color="primary" sx={{ mr: 1 }} />
              <Box>
                <Typography variant="subtitle2">Previous Officer</Typography>
                <Typography>{group.prev_officer_name || 'None recorded'}</Typography>
              </Box>
            </Box>
          </Box>
        </Paper>
      </Grid>

      {/* Quick Stats */}
      <Grid item xs={12} md={6}>
        <Paper sx={{ p: 2 }}>
          <Typography variant="h6" gutterBottom color="primary">
            Performance Metrics
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box>
              <Typography variant="subtitle2" gutterBottom>Contribution Rate</Typography>
              <LinearProgress
                variant="determinate"
                value={parseInt(group.performance?.contributionRate) || 0}
                sx={{ height: 10, borderRadius: 5 }}
              />
              <Typography variant="body2" sx={{ mt: 1 }}>
                {group.performance?.contributionRate || '0%'}
              </Typography>
            </Box>
            <Box>
              <Typography variant="subtitle2" gutterBottom>Attendance Rate(monthly)</Typography>
              <LinearProgress
                variant="determinate"
                value={parseInt(group.performance?.attendance) || 0}
                sx={{ height: 10, borderRadius: 5 }}
              />
              <Typography variant="body2" sx={{ mt: 1 }}>
                {group.performance?.attendance || '0%'}
              </Typography>
            </Box>
            <Box>
              <Typography variant="subtitle2" gutterBottom>Risk Assessment Rate</Typography>
              <LinearProgress
                variant="determinate"
                value={parseInt(group.performance?.riskAssessment) || 0}
                sx={{
                  height: 10,
                  borderRadius: 5,
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: parseInt(group.performance?.riskAssessment) > 80 ? '#4caf50' :
                                 parseInt(group.performance?.riskAssessment) > 60 ? '#ff9800' : '#f44336'
                  }
                }}
              />
              <Typography variant="body2" sx={{ mt: 1 }}>
                {group.performance?.riskAssessment || '0%'}
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Grid>

      {/* Action Buttons */}
      <Grid item xs={12}>
        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
          <Button
            variant="contained"
            startIcon={<Assessment />}
            onClick={() => setLocalActiveTab(2)}
          >
            View Performance
          </Button>
          <Button
            variant="contained"
            startIcon={<People />}
            onClick={() => setLocalActiveTab(1)}
          >
            View Members
          </Button>
          <Button
            variant="outlined"
            startIcon={<Download />}
          >
            Export Data
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default GroupOverview;